module.exports = __webpack_public_path__ + "media/bootstrap-icons/bank-79a94e54.svg";